(() => {
  angular
    .module('app')
    .controller('host.views.debugTools.fixTicketAmount.index', FixTicketAmountController);

  FixTicketAmountController.$inject = [
    '$scope',
    'abp.services.app.debugTool',
  ];

  function FixTicketAmountController($scope, debugToolSvc) {
    const vm = this;

    vm.ticketNumber = '';
    vm.result = null;
    vm.checking = false;
    vm.fixing = false;
    vm.checkError = null;
    vm.modificationRemarks = '';
    vm.showLegendExample = false;

    vm.checkAmount = checkAmount;
    vm.fixAmount = fixAmount;
    vm.isFixEligible = isFixEligible;

    $scope.$on('$viewContentLoaded', () => {
      App.initAjax();
    });

    function checkAmount() {
      vm.checkError = null;
      vm.result = null;

      if (!vm.ticketNumber || !vm.ticketNumber.trim()) {
        vm.checkError = 'Please enter a ticket number.';
        return;
      }

      vm.checking = true;
      debugToolSvc
        .getTicketAmountInfo({ ticketNumber: vm.ticketNumber.trim() })
        .success((data) => {
          vm.result = data;
          vm.modificationRemarks = '';
        })
        .error((err) => {
          vm.checkError = err && err.message ? err.message : 'An error occurred.';
        })
        .finally(() => {
          vm.checking = false;
        });
    }

    function isFixEligible() {
      if (!vm.result || !vm.result.isPossiblyIncorrect) return false;
      const eligibleTypes = ['Normal', 'Reimbursement'];
      const eligibleServices = ['GP', 'Dental', 'Optical'];
      return (
        eligibleTypes.indexOf(vm.result.ticketType) !== -1 &&
        eligibleServices.indexOf(vm.result.serviceType) !== -1
      );
    }

    function fixAmount() {
      if (vm.fixing) return;

      const stored = vm.result.storedAmount;
      const correct = vm.result.correctAmount;
      const ticket = vm.result.ticketNumber;

      abp.message.confirm(
        `Stored amount: ${stored}\nCorrect amount: ${correct}`,
        `Correct amount for ticket ${ticket}?`,
        (confirmed) => {
          if (!confirmed) return;

          vm.fixing = true;
          debugToolSvc
            .fixTicketAmount({
              ticketNumber: ticket,
              modificationRemarks: vm.modificationRemarks || undefined,
            })
            .success(() => {
              abp.notify.success(`Ticket ${ticket} amount corrected successfully.`);
              vm.result = null;
              vm.ticketNumber = '';
              vm.modificationRemarks = '';
              vm.checkError = null;
            })
            .error((err) => {
              const msg = err && err.message ? err.message : 'An error occurred.';
              abp.notify.error(msg);
            })
            .finally(() => {
              vm.fixing = false;
            });
        }
      );
    }
  }
})();
